// frontend/src/components/LandingPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";
import quironLogo from '../assets/quiron-isotipo.png'; // Import the logo
import { useTranslation } from 'react-i18next';

function LandingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isExiting, setIsExiting] = useState(false); // 1. Novo estado para animação de saída

  const handleAnimationEnd = () => {
    if (isExiting) {
      navigate("/login");
    }
  };

  const handleNavigateToLogin = () => {
    setIsExiting(true); // 2. Ativa a animação de saída
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-force-theme', 'dark');
    const loadTimer = setTimeout(() => setIsLoaded(true), 500);
    setIsExiting(false); 

    return () => {
      clearTimeout(loadTimer);
      document.documentElement.removeAttribute('data-force-theme');
    };
  }, []);

  useEffect(() => {
    const handleScrollClass = () => {
      const landingPageElement = document.querySelector(".landing-page");
      if (window.scrollY > 50) landingPageElement?.classList.add("scrolled");
      else landingPageElement?.classList.remove("scrolled");
    };
    window.addEventListener("scroll", handleScrollClass);
    return () => window.removeEventListener("scroll", handleScrollClass);
  }, []);

  return (
    // 3. Aplica a classe 'exiting' dinamicamente
    <div
      className={`landing-page ${isLoaded ? "loaded" : ""} ${isExiting ? "exiting" : ""}`}
      onTransitionEnd={handleAnimationEnd} // Adiciona o handler aqui
    >
      <div className="light-ambient-effect"></div>
      <div className="light-rays-effect"></div>
      <div className="light-glow-effect"></div>
      <div className="global-background-overlay"></div>
      <div className="content-wrapper">
        <header>
          <div className="logo"> {/* Updated logo structure */}
            <img src={quironLogo} alt="Quiron Logo" className="logo-img" />
            <span className="logo-text">Quiron</span>
          </div>
          <nav>
            <ul>
              <li><a href="#casos-de-uso">{t('useCases')}</a></li>
              <li><a href="#noticias">{t('news')}</a></li>
              <li><a href="#comunidade">{t('community')}</a></li>
            </ul>
          </nav>
          {/* Botão "Começar" no header */}
          <button className="cta" onClick={handleNavigateToLogin}>{t('getStarted')}</button>
        </header>
        <section className="hero" id="hero">
          <div className="hero-overlay"></div>
          <div className="hero-light-effect"></div>
          <h1>{t('heroTitle')}</h1>
          <p>{t('heroSubtitle')}</p>
          {/* Botão "Experimente Agora" na seção hero */}
          <button className="cta" onClick={handleNavigateToLogin}>{t('tryNow')}</button>
        </section>
        <section className="functionalities" id="casos-de-uso">
          <div className="section-light-effect"></div>
          <h2>{t('functionalities')}</h2>
          <div className="functionality-items-container">
            <div className="functionality-item">
              <div className="item-glow"></div>
              <img src="icon-consultation.png" alt={t('consultations')} />
              <p>{t('consultationManagement')}</p>
            </div>
            <div className="functionality-item">
              <div className="item-glow"></div>
              <img src="icon-chat.png" alt={t('chat')} />
              <p>{t('neuralNetwork')}</p>
            </div>
          </div>
        </section>
        <section className="testimonials" id="comunidade">
          <div className="section-light-effect"></div>
          <h2>{t('whatOurUsersSay')}</h2>
          <div className="testimonial">
            <div className="quote-light-effect"></div>
            <p>{t('testimonial1')}</p>
            <p>{t('drJoaoCardiologist')}</p>
          </div>
          <div className="testimonial">
            <div className="quote-light-effect"></div>
            <p>{t('testimonial2')}</p>
            <p>{t('draMariaNeurologist')}</p>
          </div>
        </section>
        <section className="blog" id="noticias">
          <div className="section-light-effect"></div>
          <h2>{t('latestNews')}</h2>
          <div className="blog-posts-container">
            <div className="blog-post">
              <div className="post-light-effect"></div>
              <h3>{t('telemedicineAdvancesTitle')}</h3>
              <p>{t('telemedicineAdvancesContent')}</p>
            </div>
            <div className="blog-post">
              <div className="post-light-effect"></div>
              <h3>{t('aiRevolutionizingDiagnosisTitle')}</h3>
              <p>{t('aiRevolutionizingDiagnosisContent')}</p>
            </div>
          </div>
        </section>
        <footer>
          <div className="footer-links">
            <a href="#termos">{t('termsOfUse')}</a>
            <a href="#privacidade">{t('privacyPolicy')}</a>
          </div>
          <div className="footer-contact">
            <p>{t('contactUs')}: contato@quiron.com</p>
          </div>
          <div className="footer-social">
            <a href="#facebook">Facebook</a>
            <a href="#twitter">Twitter</a>
            <a href="#instagram">Instagram</a>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default LandingPage;
